<script setup>
import {
  InformationCircleIcon,
} from "@heroicons/vue/24/outline";
import { ref, computed } from "vue";

defineProps({
  title:String
})
const isTooltipVisible = ref(false);

const showTooltip = () => {
  isTooltipVisible.value = true;
};

const hideTooltip = () => {
  isTooltipVisible.value = false;
};
</script>

<template>
  <div class="relative">
    <InformationCircleIcon class="w-5 h-5 mt-1 cursor-pointer" @mouseover="showTooltip" @mouseleave="hideTooltip"/>
    <div v-show="isTooltipVisible" class="absolute left-1/2 -translate-x-1/2 z-50 w-[300px] p-3 bg-gray-500 text-white rounded-md shadow-lg">
      <h2 class="text-sm">
       <slot/>
      </h2>
    </div>
  </div>
</template>

<style scoped>
.tooltip-visible {
  opacity: 1;
  transition: opacity 0.3s ease-in-out; /* Add transition for opacity */
}
 
</style>
